import classNames from "classnames";
import { type FC, type ReactNode } from "react";

import { getStyle } from "helpers/validators";
import styles from "./Text.module.scss";

export interface TextProps {
  children: ReactNode;
  tag?: keyof JSX.IntrinsicElements;
  weight?: "regular" | "semibold";
  size?: "s" | "m" | "l";
  color?: "default" | "white";
  className?: string;
  testId?: string;
}

export const Text: FC<TextProps> = ({
  children,
  tag = "span",
  weight = "regular",
  size = "m",
  color,
  className,
  testId,
}) => {
  const Tag = tag;

  return (
    <Tag
      className={classNames(
        styles.text,
        getStyle(styles, "weight", weight),
        getStyle(styles, "size", size),
        getStyle(styles, "color", color),
        className,
      )}
      data-testid={testId}
    >
      {children}
    </Tag>
  );
};
